module.exports = __webpack_public_path__ + "img/topup_on_s.39e2aea7.svg";